import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveSupplierInventoryWarehouseStatus } from './index';

// Api's
import { supplierInventoryWarehouseStatusApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getSupplierInventoryWarehouseStatusSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      supplierInventoryWarehouseStatusApi.getDomain
    );

    if (response.data.result) {
      yield put(saveSupplierInventoryWarehouseStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveSupplierInventoryWarehouseStatus(null, true, resultError.messagesDataError));
    }
  }
}
